import { useState, useEffect } from 'react';
import { cookieUtils } from '@/utils/cookieUtils';

/**
 * Hook to manage account verification ID
 * Replaces Redux accountVerificationId state with cookie-based storage
 */
export const useAccountVerificationId = () => {
    const [accountVerificationId, setIdState] = useState<string | null>(() =>
        cookieUtils.getAccountVerificationId() || null
    );

    const setAccountVerificationId = (id: string | null) => {
        if (id) {
            cookieUtils.setAccountVerificationId(id);
            setIdState(id);
        } else {
            cookieUtils.removeAccountVerificationId();
            setIdState(null);
        }
    };

    // Sync with cookie changes
    useEffect(() => {
        const cookieId = cookieUtils.getAccountVerificationId() || null;
        if (cookieId !== accountVerificationId) {
            setIdState(cookieId);
        }
    }, [accountVerificationId]);

    return {
        accountVerificationId,
        setAccountVerificationId,
    };
};
